<template>
    <div class="login-bg">
        <div class="login">
            <img @click="loginHide" class="login-close" :src="close_img"/>
            <div class="login-title">账号登录</div>
            <p class="login-regist">没有帐号?现在去<span @click="registShow">注册</span></p>
            <el-form :model="ruleForm" :rules="rules">
                <el-form-item class="input" prop="account">
                    <el-input  type="text" v-model="ruleForm.account" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item class="input" prop="password">
                    <el-input  type="password" v-model="ruleForm.password" placeholder="密码"></el-input>
                </el-form-item>
                <el-button class="button" @click="loginIn" v-bind:disabled="!checked" :loading="buttonLoading">立即登录</el-button>
            </el-form>
            <div class="wx-login"><span class="login-line left"></span>微信登录<span class="login-line right"></span></div>
            <img class="wx-logo"  @click="wxloginShow" :src="weixin_img" />
            <div class="choose-bg"></div>
            <div class="choose"><el-checkbox class="checkbox" v-model="checked"></el-checkbox><a href="">勾选即代表您同意接受《某某某政策》</a></div>
        </div>
    </div>
</template>

<script>
import close_img from '@assets/image/icon/close.png'
import weixin_img from '@assets/image/icon/weixin.png'

export default {
    data(){
        return {
            close_img,
            weixin_img,
            buttonLoading:false,
            ruleForm:{
                account:'',
                password:''
            },
            checked:false,
            rules:{
                account:[
                    { required: true, message: '请输入您的手机号', trigger: 'blur'},
                ],
                password:[
                    { required: true, message: '请输入您的密码', trigger: 'blur'},
                ],
            }
        }
    },
    mounted(){

    },
    methods:{
        loginHide(){
            this.$parent.loginHide()
        },
        wxloginShow(){
            this.$parent.wxloginShow()
        },
        registShow(){
            this.$parent.registShow()
        },
        goIndex(){
            this.$router.push('/')
        },
        loginIn(){
            var that = this
            this.buttonLoading = true
            console.log(this.ruleForm)
            this.axios.get(this.url+'/api/user/login',{params:this.ruleForm}).then(function(response){
                if(response.data.code == 1){
                    that.$message({
                        message: "登录成功",
                        type: 'success'
                    });
                    that.buttonLoading = false
                    that.$store.commit('setHeadImgUrl',response.data.data.userinfo.avatar)
                    that.$store.commit('setNickName',response.data.data.userinfo.nickname)
                    that.$store.commit('setToken',response.data.data.userinfo.token)
                    that.$store.commit('setUserId',response.data.data.userinfo.user_id)
                    that.loginHide()
                }else{
                    that.$message({
                        message: '登录失败',
                        type: 'warning'
                    });
                    that.buttonLoading = false
                }
            }).catch(function() {
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.login-bg{
    width: 100%;
    height: 100vh;
    top:0;
    position: fixed;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 100;
}
.login{
    width: 35rem;
    height: auto;
    background: #fff;
    border-radius: 4px;
    top:50%;
    bottom: 50%;
    color: $color;
    padding:3rem 6rem 0;
    margin:-13.2rem auto 0;
    position: relative;
}
.login-close{
    position: absolute;
    top:0.5rem;
    right: 0.5rem;
    cursor: pointer;
}
.login-title{
    font-size: 1.5rem;
}
.login-regist{
    text-align: right;
    font-size: 0.8rem;
    line-height: 1.6rem;
    cursor: pointer;
    span{
        color: #a22915;
    }
}
.login-line{
    width: 7.5rem;
    display:inline-block;
    margin-bottom: 0.3rem;
	border: solid 1px #c0c0c0;
}
.left{
    margin-right: 1rem;
}
.right{
    margin-left: 1rem;
}
.input{
    margin-bottom: 1.5rem;
}
.button{
    width: 100%;
    background: $color;
    color: #fff;
    margin-bottom: 2.5rem;
}
.wx-login{
    width: 100%;
    text-align: center;
    color: #c1c1c1;
    font-size: 1rem;
}
.wx-logo{
    display: block;
    width: 2.3rem;
    height: 2.3rem;
    margin:1rem auto;
    cursor: pointer;
}
.choose{
    width: 100%;
    height: 2.5rem;
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 0.8rem;
    color: #a6a6a6;
    line-height:2.5rem;
    text-align: center;
    background: #f6f6f6;
}
.choose-bg{
    width: 100%;
    height: 2.5rem;
}
.checkbox{
    margin-right: 0.5rem;
}
</style>